import { Layout, Dropdown } from "antd";
import { DownOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { ConnectedProps } from "react-redux";
import { useNavigate } from "react-router-dom";

import { NavigationPath, ROLES, navbarMenuItems as items } from "../../utils";
import logo from "../../images/logo.svg";
import connector from "./Container";

const { Header } = Layout;

const Navbar = ({ actions, state }: ConnectedProps<typeof connector>) => {
  const { user } = state;
  const navigate = useNavigate();

  return (
    <Header className="bg-secondary flex items-center justify-between h-24">
      <img width={136} src={logo} alt="logo" />
      <div className="flex items-center">
        {user?.role !== ROLES.INSURANCE_COMPANY && (
          <span
            onClick={() => navigate(NavigationPath.ADD_OFFER_REQUEST_ROUTE)}
            className="hidden sm:flex text-white mr-4 cursor-pointer items-center"
          >
            <PlusCircleOutlined className="text-2xl mr-2 align-middle" />
            Kreiraj zahtjev za ponudu
          </span>
        )}

        <Dropdown
          className="h-8"
          trigger={["click"]}
          menu={{
            items,
            onClick: () => actions.logoutUser(),
          }}
        >
          <a className="flex items-center" onClick={(e) => e.preventDefault()}>
            <img src="/favicon.ico" alt="logo" className="h-6 ml-2" />
            <div className="text-white ml-2 mr-3 text-sm">
              {user?.role && user.role}
            </div>
            <DownOutlined className="text-white" />
          </a>
        </Dropdown>
      </div>
    </Header>
  );
};

export default Navbar;
